var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-page"},[_c('div',{staticClass:"detail-page__right"},[_c('WarehouseManagementCreation')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }